module.exports = __webpack_public_path__ + "static/media/magnifying-glass.c0c6dd21.svg";